import { render, staticRenderFns } from "./EvaluacionDesempenioInstitucionalDialogComponent.vue?vue&type=template&id=a90b7576"
import script from "./EvaluacionDesempenioInstitucionalDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionDesempenioInstitucionalDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports